export class Settings {
    static language() {
        return document.documentElement.lang.substr(0, 2).toLowerCase();
    }
}